import Accordion from '@/components/Accordion';

import { getSubTotalPrice } from '@/api/cart';
import ProductListItem from '@/components/ProductListItem';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { useEffect, useImperativeHandle, useState } from 'react';
import { useTranslations } from 'next-intl';
interface ProductListPCProps {
  formattedList: any[];
  allQty: number;
  showList: boolean;
  toggleShowList: () => void;
  giftNum: number;
  redeemCartId: string | null;
  ref: React.RefObject<any>;
}

export default function ProductListPC({
  formattedList,
  allQty,
  showList,
  toggleShowList,
  giftNum,
  redeemCartId,
  ref,
}: ProductListPCProps) {
  const t = useTranslations('payment.ProductList');
  const currency = useStore((state) => state.currency);
  // const landingPage = useStore((state) => state.landingPage);
  const selectedCart = useStore((state) => state.selectedCartIds);

  const [subTotal, setSubTotal] = useState<any>({});

  // 对外暴露subTotal
  useImperativeHandle(ref, () => ({
    subTotal,
    selectedListFormPriceApi,
  }));

  const [selectedListFormPriceApi, setSelectedListFormPriceApi] = useState<any[]>([]);

  const handleSelectedCart = async () => {
    setSelectedListFormPriceApi([]);
    if (redeemCartId) return;
    if (selectedCart?.length) {
      try {
        const { data } = await getSubTotalPrice({
          currency: currency.name,
          cart_ids: selectedCart,
        });
        setSelectedListFormPriceApi(data.tmp.carts);
        setSubTotal(data);
      } catch (err) {
        logger.log(err);
      }
    }
  };
  useEffect(() => {
    handleSelectedCart();
  }, [selectedCart]);

  // 图片展示是有优先级的
  const getPreviewImage = (item) => {
    let originGlassImg = '';
    // 优先使用灰底图，没有再使用普通图片
    if (item?.image?.product_gray && item.image.product_gray.length > 0) {
      originGlassImg = item.image.product_gray[0];
    } else {
      originGlassImg = item?.image_gray || item?.img || item?.image;
    }

    return originGlassImg;
  };

  return (
    <Accordion
      items={[
        {
          key: '1',
          title: (
            <div className="flex items-center justify-between w-full">
              <h3 className="font-bb text-[18px]">{t('ProductList')}</h3>
              <div className="flex items-center text-auxiliary-text font-br text-14 mr-4">
                <span>
                  {allQty} {allQty > 1 ? t('Items') : t('Item')}
                </span>
                {Number(giftNum) > 0 && (
                  <span className="ml-10">
                    ({t('Gift')} x{giftNum || 0})
                  </span>
                )}
              </div>
            </div>
          ),
          content: (
            <div>
              {formattedList.map((item: any, index) => (
                <ProductListItem
                  key={`${item.id}-${index}`}
                  item={item}
                  selectedListFormPriceApi={selectedListFormPriceApi}
                  imageUrl={getPreviewImage(item.product_info)}
                />
              ))}
            </div>
          ),
        },
      ]}
      activeKey={showList ? '1' : '2'}
      onChange={() => toggleShowList()}
      borderless
      sx={{
        '& .MuiButtonBase-root': {
          paddingInline: '1.5625vw',
        },
        '& .MuiAccordion-root': {
          borderRadius: '5px',
          boxShadow: 'none',
        },
        '&.MuiPaper-rounded': {
          marginBottom: '0px',
        },
        '&.MuiPaper-root': {
          overflow: 'hidden',
        },
      }}
    />
  );
}
